import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '~environment';
import { RegistroUsuariosMen } from '../models/registro';
import { RegistroTienda, RegistroUsuarios } from './../models/registro';
import { AuthService } from './auth.service';
import { HttpRequestService } from './HttpRequestService';

@Injectable({
  providedIn: 'root',
})
export class UsuariosService {

  constructor(
    private http: HttpClient,
    private httpRequestService: HttpRequestService,
    private authService: AuthService,
  ) { }

  private readonly triidyServiceUrl = `${environment.apiTriidyUrl}`;
  private readonly triidyServiceUrlRest = `${environment.apiTriidyUrlRest}/api`;
  private readonly pedidosEnviaUrl = `${environment.apiEnviaUrl}`;

  getUsuario(usr: string): Observable<any[]> {
    const token = environment.serviceToken;
    const params = this.httpRequestService.getHttpParamsRequestParams({
      token,
      usr,
    });
    return this.http
      .get<any[]>(`${this.triidyServiceUrl}/ValidaUsuario`, {
        params,
      })
      .pipe(
        map((respuesta) => {
          //console.log("Este usuario es: " + respuesta[0].response);
          return respuesta;
        })
      );
  }

  getLider(id: string): Observable<any[]> {
    const token = environment.serviceToken;
    const params = this.httpRequestService.getHttpParamsRequestParams({
      token,
      id,
    });
    return this.http
      .get<any[]>(`${this.triidyServiceUrl}/GetLider`, {
        params,
      })
      .pipe(
        map((respuesta) => {
          return respuesta;
        })
      );
  }

  guardaTienda(DatosTienda: RegistroTienda): Observable<any> {
    const token = environment.serviceToken;
    DatosTienda.token = token;
    return this.http
      .post<any>(`${this.triidyServiceUrlRest}/tiendas`, DatosTienda)
      .pipe(
        map((respuesta) => {
          return respuesta;
        })
      );
  }

  guardaUsuario(DatosUser: RegistroUsuarios): Observable<any> {
    const token = environment.serviceToken;
    DatosUser.token = token;
    return this.http
      .post<any>(`${this.triidyServiceUrlRest}/usuarios`, DatosUser)
      .pipe(
        map((respuesta) => {
          return respuesta;
        })
      );
  }

  guardaUsuario2(DatosUser: RegistroUsuariosMen): Observable<any> {
    const token = environment.serviceToken;
    DatosUser.token = token;
    return this.http
      .post<any>(`${this.triidyServiceUrlRest}/usuarios`, DatosUser)
      .pipe(
        map((respuesta) => {
          return respuesta;
        })
      );
  }

  getBase(): Observable<any[]> {
    const token = environment.serviceToken;
    const params = this.httpRequestService.getHttpParamsRequestParams({
      token
    });
    return this.http
      .get<any[]>(`${this.triidyServiceUrl}/GetDataBase`, {
        params,
      })
      .pipe(
        map((respuesta) => {
          return respuesta;
        })
      );
  }

  preRegistroUsuario(DatosUser, lider): Observable<any> {
    const token = environment.serviceToken;
    const params = this.httpRequestService.getHttpParamsRequestParams({
      token: token,
      id_lider: lider,
      email: DatosUser.correo,
      tienda: DatosUser.nombreT
    })

    return this.http
      .get<any>(`${this.triidyServiceUrl}/PreRegistro`, { params })
      .pipe(
        map((respuesta) => {
          return respuesta;
        }, (err) => {
          console.log(err);
        })
      );
  }
}
